/**
 * @class FJVideoManager
 * @classdesc 视频标签池
 */
let FJVideoManager = (function () {
  let _videos = [];
  return {

    /**
     * @description 视频是否闲置
     * @param video
     * @return {boolean|number|string}
     */
    isVideoIdle: function (video) {
      return video.idle;
    },

    /**
     * @description 获取闲置的视频标签
     * @return {element}
     */
    getVideo: function () {
      let video = _videos.find(v => this.isVideoIdle(v));
      if (!video) {
        video = document.createElement('video');
        video.setAttribute('preload', 'auto');
        _videos.push(video);
      }

      video.idle = false;

      return video;
    },

    /**
     * @description 视频视频标签
     * @param {element} video
     */
    releaseVideo: function (video) {
      if (!video) {
        return;
      }
      if (video.isPlaying) {
        video.pause();
      }
      video.src = '';
      video.idle = true;
    },

    /**
     * @description 打印使用情况
     */
    logInfo: function () {
      let idleVideos = _videos.filter(video => video.idle);
      console.log(`%cAll video's count: ${_videos.length}, idle video's count: ${idleVideos.length}`, 'background: lightblue')
    }
  }
})();

export default FJVideoManager;
